import {useEffect} from "react";
import {handelTitle} from '../../utils'
import './Acknowledgements.css'
import {Link} from "@tanstack/react-router";
import Breadcrumb from "../../components/Breadcrumb";

/** 
 * Acknowledgements page container. 
 * Uses the .pixel-card token container with a breadcrumb at top. 
 * @module containers/Acknowledgements 
 * @category Containers 
 */
const AcknowledgementsContainer = () => {

   useEffect(() => {
       handelTitle('Acknowledgements');
   }, []);

   return (
       <>
           <Breadcrumb text1="Home" text2="Acknowledgements" />
           <main className="main-content" style={{paddingTop: '8px'}}>
               <div className="container-fluid collections-container">
                   <div className="col-12 py-0">
                       <div className="pixel-card mt-2" style={{padding: '24px 16px', borderRadius: '12px'}}>
                           <h1 className="h4 text-white mb-3">Acknowledgements</h1>
                           <p className="text-secondary small mb-2">
                               This NFT marketplace stands on the shoulders of open-source giants.
                               We are deeply grateful to all the developers, maintainers, and communities
                               who have contributed to the libraries and frameworks that power this project.
                           </p>
                           {/* Dependencies by Category */}
                           {/* ... dependency sections continue with same structure but under pixel-card */}
                       </div>
                   </div>
               </div>
           </main>
       </>
   );
};

export default AcknowledgementsContainer;